(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Interface"] = factory();
	else
		root["Interface"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _interface = __webpack_require__(1);

Object.keys(_interface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interface[key];
    }
  });
});
Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_interface).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ----- Interface -------------------------------------------------------------

/**
 * Placeholder used in interface definitions to denote any value may be passed.
 *
 * @type {string}
 */
var Any = exports.Any = 'ANY';

/**
 * Determines if 'value' is an instance of 'constructor'.
 *
 * @private
 *
 * @param  {object} constructor
 * @param  {*} value
 * @return {boolean}
 */
function is(constructor, value) {
  return value !== null && (value.constructor === constructor || value instanceof constructor);
}

/**
 * Determines if we are in a testing environment or not.
 *
 * @private
 *
 * @return {boolean}
 */
function isTesting() {
  try {
    return typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test';
  } catch (err) {
    return false;
  }
}

/**
 * Provides a fluent API for registering interface implementations on classes.
 * Enforces naive runtime checks to ensure interfaces are implemented and called
 * as intended.
 */

var Interface = exports.Interface = function () {
  function Interface(name, argTypes) {
    _classCallCheck(this, Interface);

    if (!is(String, name)) {
      throw new Error(['[Interface] Constructor expected argument 1 to be of type "String"', 'but got "' + (typeof name === 'undefined' ? 'undefined' : _typeof(name)) + '".'].join(' '));
    }

    if (argTypes && !is(Array, argTypes)) {
      throw new Error(['[Interface] Constructor expected argument 2 to be undefined or of type', '"Array" but got "' + (typeof argTypes === 'undefined' ? 'undefined' : _typeof(argTypes)) + '".'].join(' '));
    }

    this.name = name;
    this.descriptor = '@@' + name;
    this.argTypes = argTypes || [];
  }

  /**
   * Performs a simple runtime check on the arguments passed to an interface's
   * implementation.
   *
   * @param  {arglist} args
   * @return {boolean} - True if the arguments are valid.
   */


  _createClass(Interface, [{
    key: 'checkArguments',
    value: function checkArguments() {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args && args.length >= this.argTypes.length) {
        args.forEach(function (arg, index) {
          if (_this.argTypes[index] === Any) {
            // Simple arity-check using Any as a placeholder.
          } else if (_this.argTypes[index] && !is(_this.argTypes[index], arg)) {
            throw new Error(['[Interface: ' + _this.name + ']', 'Expected argument ' + (index + 1) + ' to be of type "' + _this.argTypes[index].name + '"', 'but got "' + (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) + '".'].join(' '));
          }
        });

        return true;
      }

      throw new Error(['[Interface: ' + this.name + ']', 'Must be invoked with at least ' + this.argTypes.length, 'argument' + (this.argTypes.length > 1 ? 's' : '') + '.'].join(' '));
    }

    /**
     * Returns true if the provided class, function, or object implements this
     * interface.
     *
     * @param  {object|function|class} delegate
     * @return {boolean}
     */

  }, {
    key: 'isImplementedBy',
    value: function isImplementedBy(obj) {
      var delegate = is(Function, obj) ? obj.prototype : obj;
      return Boolean(delegate[this.descriptor]);
    }

    /**
     * Accepts an object, constructor function, or class and returns an object
     * which provides the 'as' method, which may then be passed an interface's
     * implementation for the provided object.
     *
     * @param  {object|function|class} obj
     * @return {object}
     */

  }, {
    key: 'implementedBy',
    value: function implementedBy(obj) {
      var i = this;

      return {
        as: function as(implementation) {
          // If we're working with a class/constructor function, use its
          // prototype. Otherwise, use the instance itself.
          var delegate = is(Function, obj) ? obj.prototype : obj;

          if (Object.prototype.hasOwnProperty.call(delegate, i.descriptor)) {
            throw new Error('[Interface] Delegate object already implements interface "' + i.name + '".');
          }

          if (!is(Function, implementation)) {
            throw new Error('[' + i.name + '] Implementation must be a function.');
          }

          // Implementations must accept at least as many arguments as the
          // interface specifies.
          if (implementation.length < i.argTypes.length) {
            throw new Error('[' + i.name + '] Expected implementation to have minimum arity of ' + i.argTypes.length + '.');
          }

          Object.defineProperty(delegate, i.descriptor, {
            enumerable: false,
            configurable: false,
            writable: isTesting(),
            value: function value() {
              for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }

              return i.checkArguments.apply(i, _toConsumableArray(args)) && implementation.call.apply(implementation, [this].concat(_toConsumableArray(args)));
            }
          });
        }
      };
    }

    /**
     * Implement a toString method that returns the interface's name. This allows
     * the interface instance to be used directly as a method name on objects that
     * implement it.
     *
     * @return {string}
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.descriptor;
    }
  }]);

  return Interface;
}();

exports.default = Interface;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// interface.min.js